<div id="layout-wrapper">
  <app-horizontaltopbar *ngIf="!isStreamingwindows" ></app-horizontaltopbar>

  <div class="main-content" *ngIf="!isStreamingwindows">
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div *ngIf="isStreamingwindows">
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </div>
  
  <app-footer *ngIf="!isStreamingwindows"></app-footer>
  <app-rightsidebar *ngIf="!isStreamingwindows"></app-rightsidebar>
</div>
